import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export class ApbState {
	public warningModal: ApbModalState;
	constructor() {
		const adapter: EntityAdapter<ApbModalState> = createEntityAdapter<ApbModalState>();

		this.warningModal = adapter.getInitialState({});
	}
}

export interface ApbModalState extends EntityState<ApbModalState> {}
